import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, AbstractControl } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-fixed-bp-line-list-validation',
  templateUrl: './fixed-bp-line-list-validation.component.html',
  styleUrls: ['./fixed-bp-line-list-validation.component.scss']
})
export class FixedBpLineListValidationComponent implements OnChanges {
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  bpLineFormArray: UntypedFormArray;
  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3' , 'Validation 4'];
  // tslint:disable-next-line: max-line-length
  displayedColumnsBp: string[] = ['nBc', 'libelle', 'qteBc', 'qteRest', 'qteLivre', 'qteBp', 'puBc', 'puBp', 'htBc', 'htRest', 'htBp', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'Equipement', 'CodeChantier', 'ttc'];
  matDataSourceBpLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  CREATION = false;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.form) {
      this.bpLineFormArray = this.form.controls['bpLines'] as UntypedFormArray;
      this.reload();
    }
    this.displayedColumnsBp = ['nBc', 'libelle', 'qteBp', 'puBp', 'htBp', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'Equipement', 'CodeChantier', 'ttc'];
  }

  reload(): void {
    if (this.bpLineFormArray) {
      this.matDataSourceBpLigne = new MatTableDataSource<AbstractControl>(this.bpLineFormArray.controls);
    }
  }
}
